import { Launch } from '@mui/icons-material';

import SideDrawer from '@/components/SideDrawer';
import ExportDrawerEmptyState from '@/features/DataHub/components/ExportDrawer/EmptyState';
import { ExportConfigView } from '@/features/DataHub/components/ExportDrawer/ExportConfigView';
import { useExportHistory } from '@/features/DataHub/hooks/useExportHistory';
import { useOnOpen } from '@/features/DataHub/hooks/useOnOpen';
import { useExport } from '@/features/DataHub/modules/Export/context/ExportContext';
import { PastExports } from '@/features/DataHub/pages/PastExports';

interface ExportDrawerProps {
  open: boolean;
  onClose: () => void;
}

const ExportDrawer = ({ open, onClose }: ExportDrawerProps) => {
  const { showHistory, toggleHistory } = useExportHistory();
  const { resetExportState, uniqueSymbols } = useExport();

  const hasSymbols = uniqueSymbols.size > 0;

  useOnOpen(open, () => {
    resetExportState();
  });

  const renderContent = () => {
    if (showHistory) {
      return <PastExports />;
    }

    if (!hasSymbols) {
      return <ExportDrawerEmptyState />;
    }

    return <ExportConfigView openKey={open.toString()} />;
  };

  return (
    <SideDrawer
      icon={
        <Launch
          sx={{
            fontSize: 32
          }}
        />
      }
      isHistoryActive={showHistory}
      open={open}
      title='Export'
      onClose={onClose}
      onHistoryClick={toggleHistory}
    >
      {renderContent()}
    </SideDrawer>
  );
};

export default ExportDrawer;
